
/**
 * External dependencies
 */
import { useBlockProps } from '@wordpress/block-editor';
import clsx from 'clsx';
import { __ } from '@wordpress/i18n';

/**
 * Internal dependencies
 */
import EditFields from './edit-fields';
import Noninteractive from '../components/noninteractive';

export const Edit = ({
	attributes,
	setAttributes
}) => {

	const blockProps = useBlockProps();
	const { sectionData } = attributes;

   const fields = Array.isArray(sectionData?.fields) 
   ? sectionData.fields 
   : Object.values(sectionData?.fields || {});

	return (
		<div {...blockProps}>
			{ fields.map((field) => {

				return (
					<div key={field.id} className="wc-block-checkout__thwcfe-contact-fields__field">
						<Noninteractive>
							<EditFields field={field}/>
						</Noninteractive>
					</div>
				);
			})}
		</div>
	);
};

export const Save = () => {
	//return <div { ...useBlockProps.save() } />;
	return (
		<div>

		</div>
	);
};

